import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { Edit, Info, Image as ImageIcon, MoreVertical } from "react-feather";

export const MenuOptions = ({ params, Actions }) => {
    const { idcollateral } = params.data;

    const {
        handleClickFetchInfoCollateral,
        handleClickOpenCollateralImages,
    } = Actions;

    // --- Menú OPCIONES (único) ---
    const [anchorOptions, setAnchorOptions] = useState(null);
    const openOptions = Boolean(anchorOptions);

    const handleOpenOptions = (e) => setAnchorOptions(e.currentTarget);
    const handleCloseOptions = () => setAnchorOptions(null);

    return (
        <>
            {/* BOTÓN OPCIONES */}
            <Button
                startIcon={<MoreVertical />}
                variant="contained"
                size="small"
                color="success"
                onClick={handleOpenOptions}
                style={{ width: 170 }}
            >
                Opciones
            </Button>

            <Menu anchorEl={anchorOptions} open={openOptions} onClose={handleCloseOptions}>
                {/* VER DATOS */}
                <MenuItem
                    onClick={() => {
                        handleClickFetchInfoCollateral(idcollateral, "READONLY");
                        handleCloseOptions();
                    }}
                >
                    <ListItemIcon>
                        <Info color="black" />
                    </ListItemIcon>
                    <ListItemText primary="Ver datos" />
                </MenuItem>

                {/* EDITAR DATOS */}
                <MenuItem
                    onClick={() => {
                        handleClickFetchInfoCollateral(idcollateral, "EDITABLE");
                        handleCloseOptions();
                    }}
                >
                    <ListItemIcon>
                        <Edit color="black" />
                    </ListItemIcon>
                    <ListItemText primary="Editar datos" />
                </MenuItem>

                {/* EDITAR IMÁGENES */}
                <MenuItem
                    onClick={() => {
                        handleClickOpenCollateralImages(idcollateral, "EDITABLE");
                        handleCloseOptions();
                    }}
                >
                    <ListItemIcon>
                        <ImageIcon color="black" />
                    </ListItemIcon>
                    <ListItemText primary="Editar imágenes" />
                </MenuItem>
            </Menu>
        </>
    );
};